import { Box } from '@mui/material'
import { MOBILE_MQ, mobileButtonSx, responsiveButtonSx } from '../../theme/mobileLayout'
import { eventFilters } from '../../data/eventsContent'
import { buttonHoverFilterSx } from '../../theme/buttonHover'
import ButtonText from '../common/ButtonText'

export default function EventsFilterTabs({ activeFilter, onFilterChange }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px',
        alignItems: 'center',
        [MOBILE_MQ]: {
          flexWrap: 'nowrap',
          overflowX: 'auto',
          pb: '4px',
          mx: '-20px',
          px: '20px',
          WebkitOverflowScrolling: 'touch',
          '&::-webkit-scrollbar': { display: 'none' },
        },
      }}
    >
      {eventFilters.map((filter) => {
        const isActive = activeFilter === filter.id
        return (
          <Box
            key={filter.id}
            component="button"
            type="button"
            onClick={() => onFilterChange(filter.id)}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              fontFamily: 'inherit',
              ...responsiveButtonSx,
              [MOBILE_MQ]: mobileButtonSx,
              ...buttonHoverFilterSx(isActive),
            }}
          >
            <ButtonText
              sx={{
                fontSize: { xs: 13, sm: 16 },
                [MOBILE_MQ]: { fontSize: 13 },
                lineHeight: 'normal',
                fontWeight: 400,
                whiteSpace: 'nowrap',
              }}
            >
              {filter.label}
            </ButtonText>
          </Box>
        )
      })}
    </Box>
  )
}
